// VanJS Feather - Unlock
import van from "vanjs-core";
import { FeatherIcon, svgNamespace } from "../FeatherIcon.ts";
import { type SVGProps } from "../types.ts";

export const Unlock = (props: Partial<SVGProps> = {}) => {
  const { rect, path } = van.tags(svgNamespace);

  return FeatherIcon(
    props,
    rect({
      "x": "3",
      "y": "11",
      width: "18",
      height: "11",
      rx: "2",
      ry: "2",
    }),
    path({ "d": "M7 11V7a5 5 0 0 1 9.9-1" }),
  );
};
